// /components/CookieBanner/sub/CookieOption/CookieOption.jsx
import './CookieOption.css';

export default function CookieOption({title, text, blocked, checked, onToggle}) {
    return (
        <div className='cookie-option'>
            <div className='cookie-option-left'>
                <h4 className='cookie-option-title'>
                    <strong>{title}</strong>
                </h4>
                <span className='cookie-option-text'>{text}</span>
            </div>
            <div className='cookie-option-right'>
                <label className={`switch ${blocked ? 'switch--blocked' : ''}`}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                            if (blocked) return;
                            onToggle?.();
                        }}
                    />
                    <span className={`slider ${blocked ? 'slider--blocked' : ''}`}></span>
                </label>
            </div>
        </div>
    );
}
